import ProhibitedCategoryRegister from '../../components/layout/ITHeadquarters/prohibitedCategoryRegister';

const ExceptionCategoryPage = () => {
    return <ProhibitedCategoryRegister isException />;
};
export default ExceptionCategoryPage;
